<template>
    <vgloballayout
        :loading="loading"
        :error="error"
        @reload="organizationListContacts"
    >
        <div slot=body>
            <el-form ref="form" >

                <el-card class="box-card" v-loading="loading">
                    <div slot="header" class="clearfix">
                        <el-row type="flex" justify="space-between">
                            <span>Контакты</span>
                            <addContact />
                        </el-row>
                    </div>

                    <div v-for="(item, index) in getOrganizationListContacts" :key="index" class="text item m-b-15 block-contact">
                        <div class="card-contact">
                            <el-row type="flex"  justify="end">
                                <el-col :span="3">
                                    <editContact
                                        :contact="item"
                                        :index="index"
                                        />
                                </el-col>
                                <el-col :span="3">
                                    <deleteContact 
                                        :index="index" 
                                        :id="item.id"
                                        />
                                </el-col>
                            </el-row>
    

                            <div class="card-contact-item">
                                <span>Должность: </span>
                                <span>{{ item.position  }}</span>
                            </div>
                            <div class="card-contact-item">
                                <span>Имя: </span>
                                <span>{{ item.contactName  }}</span>
                            </div>
                            <div class="card-contact-item">
                                <span>Телефон: </span>
                                <span>{{ item.phone  }}</span>
                            </div>
                            <div class="card-contact-item">
                                <span>Комменатрий: </span>
                                <span>{{ item.description  }}</span>
                            </div>
                            <div class="card-contact-item">
                                <span>Часы работы: </span>
                                <span>{{ item.receptionHours  }}</span>
                            </div>
                            
                        </div>
                    </div>

                </el-card>

            </el-form>
        </div>
    </vgloballayout>
</template>

<script>

import { mapGetters } from 'vuex'
import deleteContact from './modal/delete-contact'
import editContact from './modal/edit-contact'
import addContact from './modal/add-contact'

export default {
    data() {
        return {
            loading: false,
            error: false
        }
    },
    mounted() {
        this.organizationListContacts()
    },
    computed: {
        ...mapGetters([
            'getOrganizationListContacts'
        ])
    },
    methods: {

        async organizationListContacts() {
            this.loading = true
            this.error = false

            try {
                this.dopContact = await this.$store.dispatch('organizationListContacts')
            }catch(e) {
                this.error = this.$ErrorsMod(e)
            }

             this.loading = false
        }
        
    },
    components: {
        deleteContact, addContact, editContact
    }
}

</script>

<style scoped>
    .block-contact {
        border-bottom: 1px solid #F3F3F3;
        padding: 0 0 10px 0;
        font-size: 14px;
    }

</style>

